import React, { useState, useRef, useEffect } from 'react';
import { Validaciones, Encriptar } from '@renedelangel/helpers';
import AssignmentTurnedInIcon from '@material-ui/icons/AssignmentTurnedIn';
import SyncProblemIcon from '@material-ui/icons/SyncProblem';
// Redux
import { useSelector } from 'react-redux';
// master components
import Tabla from '../../../_layout/masterComponents/Tabla';
import FormularioModal from '../../../_layout/masterComponents/FormularioModal';
import Modal from '../../../_layout/genericComponents/Modal';

// generic components
import SweetAlert from '../../../_layout/genericComponents/ModalConfirmacion';
//storage
import { actualizaArchivo, eliminaArchivo } from "../../../helpers/serverStorage";
import PictureAsPdfIcon from '@material-ui/icons/PictureAsPdf';
// material-ui icons
import Add from "@material-ui/icons/Add";
import Edit from "@material-ui/icons/Edit";
import Close from "@material-ui/icons/Close";
import SyncIcon from '@material-ui/icons/Sync';
import SaveIcon from '@material-ui/icons/Save';
import UnarchiveIcon from '@material-ui/icons/Unarchive';
import { RiFileExcel2Fill } from "react-icons/ri";

import { NetworkError } from "../../../_layout/genericComponents/Metodos";
import RecordVoiceOverIcon from '@material-ui/icons/RecordVoiceOver';

import { handleFocus, handleErrorInputText, handleModificar, handelAlertEliminar, handleEliminar, handleGuardar, handleAlertMutationGeneric, handleAlertGeneric } from '../../../_layout/helpers/handles';
import { info, danger, success, primary, black } from '../../../_layout/helpers/colores';
import * as Consultas from './Consultas.js';
import * as ConsultasEmpresas from '../Empresas/Consultas.js';
import * as ConsultasReporteDanios from '../ReporteDanios/Consultas.js';
import moment from 'moment';
import { Switch, useLocation, useHistory } from 'react-router-dom';
import { urlServidor } from '../../../helpers';
import { rgxdeInt2 } from 'helpers/regexp';
import { seleccionArea } from '../../../querys/Areas';
import { seleccionUbicaciones } from '../../../querys/Ubicaciones'
import * as Permisos from '../Permisos';
import Automoviles from '../ActivosAsegurado/Automoviles';
import Documentacion from '../Documentacion';

function IconoSimbolo({ simbolo = "" }) { return (<span>{simbolo}</span>); }

const { trim } = Validaciones;

function ReporteDaniosClientes() {
    const { token, usuario } = useSelector(stDatos => stDatos.login);
    const { Encrypt } = Encriptar;
    let anioActual = new Date().getFullYear();
    let cFechaFiltroInicial = anioActual + "0101";
    let cFechaFiltroFinal = anioActual + "1231";

    let Empresas = [];
    let remover = false;
    const cleanState = {};
    const cleanErrorState = {}
    const cleanNotificaciones = { mensaje: "", color: null, open: false };
    const [stEmpresas, setEmpresas] = useState(Empresas)
    const [stReporteDanios, setReporteDanios] = useState(Empresas)

    let [datosPDF, setdatosPDf] = useState({});
    // Seleccionables
    const [seleccionables, setSeleccionables] = useState({});
    const [stTituloTipoDanio, setTituloTipoDanio] = useState("")
    let [stDatos, setState] = useState(cleanState);
    const [errorState, setErrorState] = useState(cleanErrorState);
    const [notificaciones, setNotificaciones] = useState(cleanNotificaciones);
    const [open, setOpen] = useState(false);
    const [disabled, setDisabled] = useState(false);
    const [alert, setAlert] = useState(null);
    const [loader, setLoader] = useState(false);
    const [actualizar, setActualizar] = useState(false);
    const [stFotografia1, setFotografia1] = useState({ valor: "", file: "", eliminar: remover });
    const [stFotografia2, setFotografia2] = useState({ valor: "", file: "", eliminar: remover });

    const [abrirSeguimiento, setAbrirSeguimiento] = useState(false);
    const cleanNotificacionesSeguimiento = { mensaje: "", color: null, open: false };
    const [notificacionesSeguimiento, setnotificacionesSeguimiento] = useState(cleanNotificacionesSeguimiento);
    const [seguimientoSelect, setseguimientoSelect] = useState("SIN RECLAMACIÓN");
    const [stCerrarReporte, setCerrarReporte] = useState({});

    const [datosDetalleAdjuntos, setDatosDetalleAdjuntos] = useState({})
    const [openDocumentacion, setOpenDocumentacion] = useState(false);

    let titleAccion = stDatos.reporteDaniosCliID ? "Modificar" : "Agregar";
    let titleModal = `${titleAccion} Reporte de Servicio a Clientes`;
    let ArrayRef = [];

    const location = useLocation();
    const history = useHistory();

    const IrARuta = (pReclamo, RegistroID) => {
        let path = '/';
        if (pReclamo === 'TERCERO') {
            path = `/gen/ReclamacionATerceros`;
        } else {
            path = `/gen/SiniestrosReclamados`;
        }
        setAlert(null);
        history.push(path, { RegistroID });
    }


    let acciones = [{
        accionID: [9],
        icono: AssignmentTurnedInIcon,
        color: success,
        descripcion: "Finalizar Reporte",
        parametros: [{ campo: "reporteDaniosCliID" }, { campo: "finalizado" }, { campo: "folioInterno" }, { campo: "folioInterno"}],
        disabled: { multiseleccion: true },
        onClick: (parametros) => FinalizarReporteDaniosClientes(parametros)
    }, {
        accionID: [1, 3],
        icono: Edit,
        color: info,
        descripcion: "Modificar",
        parametros: [{ campo: "reporteDaniosCliID" }],
        disabled: { multiseleccion: true },
        onClick: (parametros) => handleModificar({
            parametros,
            token,
            setState,
            setOpen,
            setAlert,
            asyncGet: Consultas.getReporteDaniosClientes,
            formatearResultado: [{ id: "fechaElaboracion", formato: (data) => moment(data) }, { id: "fechaEvento", formato: (data) => moment(data) }, { id: "fechaIngreso", formato: (data) => moment(data) }, { id: "fechaHabilidad", formato: (data) => moment(data) }, { id: "semanaDanio", formato: (data) => moment(data) }, { id: "fechaNacimiento", formato: (data) => moment(data) }, { id: "fechaUltimaPlatica", formato: (data) => moment(data) }, { id: "fechaRevProc", formato: (data) => moment(data) }]
        })
    }, {
        accionID: [4],
        icono: Close,
        color: danger,
        descripcion: "Eliminar",
        parametros: [{ campo: "reporteDaniosCliID" },
        { campo: "folioInterno", variable: "folioInterno" }
        ],
        disabled: { multiseleccion: true },
        onClick: ({ reporteDaniosCliID, folioInterno }) => handelAlertEliminar({
            setAlert,
            mensaje: ` el reporte de daño ${folioInterno}`,
            onCancel: () => setAlert(null),
            onConfirm: () => handleEliminar({
                token,
                setAlert,
                setActualizar,
                actualizar,
                parametros: { reporteDaniosCliID, folioInterno },
                asyncDelete: Consultas.deleteReporteDaniosClientes
            })
        })
    }, {
        accionID: [5],
        icono: PictureAsPdfIcon,
        color: primary,
        descripcion: "Descargar PDF",
        parametros: [{ campo: "reporteDaniosCliID" }, { campo: "folioInterno" }],
        disabled: { multiseleccion: true },
        onClick: ({ reporteDaniosCliID, folioInterno }) => AuxDescargar(reporteDaniosCliID, folioInterno)
    },
    {
        accionID: [6],
        icono: RiFileExcel2Fill,
        color: success,
        descripcion: "Generar Excel(Largo)",
        parametros: [{ campo: "reporteDaniosCliID" }, { campo: "folioInterno" }],
        disabled: { multiseleccion: true },
        onClick: ({ reporteDaniosCliID, folioInterno }) => AuxDescargar(reporteDaniosCliID, folioInterno, 'excelFormato')
    },
    /* {
        accionID: [8],
        icono: RiFileExcel2Fill,
        color: success,
        descripcion: "Generar Excel(Corto)",
        parametros: [{ campo: "reporteDaniosCliID" }, { campo: "folioInterno" }],
        disabled: { multiseleccion: true },
        onClick: ({ reporteDaniosCliID, folioInterno }) => AuxDescargar(reporteDaniosCliID, folioInterno, 'excelCorto')
    }, */
    {
        accionID: [7],
        icono: UnarchiveIcon,
        color: info,
        descripcion: "Adjuntar",
        parametros: [{ campo: "reporteDaniosCliID" }, { campo: "folioInterno" }],
        disabled: { multiseleccion: true },
        onClick: ({ reporteDaniosCliID, folioInterno }) => {
            // setRedireccionarFormulario({ reporteDaniosCliID, folioInterno });
            setDatosDetalleAdjuntos({
                pURLDoctoOrigenID:reporteDaniosCliID ,
                pTipo:folioInterno ,
                pClasificacion: "",
                pTabla: "Reporte de daños clientes",
                pTitulo2: `Reporte de servicio a clientes folio: ${folioInterno}`,
                plUtilizaProps: true
            });
            setOpenDocumentacion(true);
        }
    }
    ];

    function setRedireccionarFormulario({ reporteDaniosCliID, folioInterno }) {

        let seed = "scrumweb";
        const datos = `{ "pURLDoctoOrigenID": "${reporteDaniosCliID}", "pTipo": "${folioInterno}", "pTabla": "Reporte de daños clientes", "pTitulo2": "Reporte de servicio a clientes folio: ${folioInterno}" }`;
        let url = Encrypt({ data: datos, seed }).replace(/\//g, "&");
        history.push(`/gen/Documentos/${url}`);
    }

    function AuxDescargar(reporteDaniosCliID, folioInterno, formatoReporte = "PDF") {
        setdatosPDf({ "reporteDaniosCliID": reporteDaniosCliID, "folioInterno": folioInterno, formatoReporte });
        datosPDF = { "reporteDaniosCliID": reporteDaniosCliID, "folioInterno": folioInterno, formatoReporte };

        handleAlertGeneric({
            setAlert,
            onCancel: () => setAlert(null),
            mensaje: {
                title: "Generar Reporte",
                descripcion: "¿Deseas generar y descargar el formato de impresión del reporte de servicio a clientes?",
                tipo: "warning",
                msjConfirmacion: "Aceptar",
                msjCancelacion: "Cancelar"
            },

            onConfirm: () => handleAlertMutationGeneric({
                token,
                setAlert,
                setActualizar,
                actualizar,
                parametros: {},
                asyncMutation: () => DescargarPdf(),
                mensajes: {
                    msjEspera: {
                        title: "Espere...",
                        descripcion: "Generando el formato de impresión del reporte de servicio a clientes ",
                        tipo: success
                    },
                    msjCorrecto: {
                        title: "Se generó con éxito",
                        descripcion: 'Se descargó el formato de impresión del reporte de servicio a clientes ' + folioInterno,
                        msjConfirmacion: "Aceptar"
                    }
                }
            })
        })
    }
    const showFile = (archivo, name = 'file.pdf',) => {
        let url = window.URL.createObjectURL(archivo);
        let a = document.createElement('a');
        a.href = url;
        a.download = name;
        a.click();
        a.remove();
    };

    async function DescargarPdf() {
        let myHeaders = new Headers();
        myHeaders.append("token", token);
        myHeaders.append("mimeType", "multipart/form-data");

        let formdata = new FormData();
        formdata.append("reporteDaniosCliID", datosPDF.reporteDaniosCliID);
        formdata.append("formatoReporte", datosPDF.formatoReporte);

        let requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata
        };

        let nombreReporte = 'ReporteDeDañosClientes' + datosPDF.folioInterno
        await fetch(`${urlServidor}/service/reportes/ReporteDeDaniosClientes`, requestOptions)
            .then(response => {
                if (!response.ok) return response.json();
                return response.blob()
            })
            .then(result => {
                let { error, mensaje } = result;
                if (error) throw new Error(mensaje);
                // showFile(result, `${nombreReporte}.pdf`);
                showFile(result, `${nombreReporte}${datosPDF.formatoReporte === 'PDF' ? '.pdf' : '.xlsx'}`); // mandar como variable dependiendo del if/case
                setAlert(null)
            })
            .catch(({ message }) => { throw new Error(message) });
    }

    function FinalizarReporteDaniosClientes(parametros) {
        if (parametros.finalizado === 1) {
            setAlert({
                descripcion: 'Este registro ya se encuentra finalizado',
                title: "Finalizar registro",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null)
            });
            return;
        }

        setAlert({
            descripcion: 'El reporte de servicio a clientes con folio ' + parametros.folioInterno + ' pasará a finalizado',
            title: "Finalizar registro",
            tipo: "success-two",
            msjConfirmacion: "Aceptar",
            onConfirm: () => ftFinalizarReporte(parametros.reporteDaniosCliID),
            msjCancelacion: "Cancelar",
            onCancel: () => setAlert(null)
        });
    }

    async function ftFinalizarReporte(reporteDaniosCliID) {
        try {
            await Consultas.FinalizarReporteDaniosClientes({ reporteDaniosCliID }, token);
            setActualizar(!actualizar);
            setAlert(null);

        } catch ({ message: descripcion }) {
            setAlert({
                descripcion: descripcion,
                title: "¡Una disculpa!",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null)
            });
        }
    }

    let botones = [{
        icono: Add,
        color: success,
        descripcion: "Agregar",
        onClick: () => setOpen(true),
        disabled: { multiseleccion: true }
    }, {
        icono: SyncIcon,
        color: info,
        descripcion: "Actualizar",
        onClick: () => setActualizar(!actualizar),
        disabled: { multiseleccion: true }
    }];

    let infoTabla = {
        botones,
        acciones,
        actualizar,
        id: "reporteDaniosCliID",
        color: primary,
        title: "Reporte de Servicio a Clientes",
        iconTable: < RecordVoiceOverIcon />,
        headers: [
            { variable: "reporteDaniosCliID", descripcion: "ID", hide: true },
            { variable: "folioInterno", descripcion: "Folio", hide: false },
            { variable: "empresaID", descripcion: "empresaID", hide: true },
            { variable: "finalizado", descripcion: "Finalizado", hide: true },
            { variable: "fechaEvento", descripcion: "Fecha Evento",  },
            { variable: "datosCarga", descripcion: "Datos Carga",  },
            { variable: "descripBreve", descripcion: "Descripción Breve",  },
            { variable: "agencia", descripcion: "Agencia",  },
            { variable: "cliente", descripcion: "Cliente",  },
            { variable: "numNC", descripcion: "Tipo Daño",  },
            { variable: "quejaReclamacion", descripcion: "Queja y/o Reclamación",  }
        ],
        responsiveTitle: ["folioInterno", "agencia", "cliente"],
        rangoFechas: { ini: "fechaIni", fin: "fechaFin", fechaInicial: moment(cFechaFiltroInicial, "YYYYMMDD"), fechaFinal: moment(cFechaFiltroFinal, "YYYYMMDD") },
        filter: [
            { campo: "folioInterno", variable: "folioInterno", placeholder: 'Buscar' },
            { campo: "agencia", variable: "agencia" ,placeholder: 'Buscar'},
            { campo: "cliente", variable: "cliente" ,placeholder: 'Buscar'},
            { campo: "datosCarga", variable: "datosCarga",placeholder: 'Buscar' },
            { campo: "descripBreve", variable: "descripBreve",placeholder: 'Buscar' },
            { campo: "numNC", variable: "numNC",placeholder: 'Buscar' },
            { campo: "quejaReclamacion", variable: "quejaReclamacion",placeholder: 'Buscar' },
        ],
        alineacion: [{ columnas: [0, 3,4, 5], alineacion: "left" }, 
        // { columnas: [1, 2], alineacion: "right" },
        ],
        selectFilter: [{
            campo: "empresaID",
            title: "Empresa",
            retorna: "number",
            limpiarFiltro: "Todos",
            data: stEmpresas ? stEmpresas : [],
            grid: { md: 3, lg: 3 }
        }],
        formato: [
            {
                columnas: ["fechaEvento", "fechaModificacion"], tipo: "fecha", onlyDate: true
            }]
    };

    const seguimiento = [{ value: "PENDIENTE", label: "PENDIENTE" },
    { value: "SIN RECLAMACIÓN", label: "SIN RECLAMACIÓN" },
    { value: "REPARADO", label: "REPARADO" },
    { value: "PAGADO", label: "PAGADO" },
    { value: "RECLAMADO A ASEGURADORA (RGR-002)", label: "RECLAMADO A ASEGURADORA (RGR-002)" },
    { value: "RECLAMADO A TERCERO (RGR-007)", label: "RECLAMADO A TERCERO (RGR-007)" }
    ];

    const inputs = [];
    const InputsConID = [];
    const Secciones = [];

    cleanErrorState["reporteDaniosCliID"] = { error: false, helperText: "" };
    cleanState["reporteDaniosCliID"] = 0;
    cleanState["empresaID"] = 0;
    cleanState["estatus"] = 'EN PROCESO';
    cleanState["seguimiento"] = 'PENDIENTE';
    cleanState["finalizado"] = 0;
    cleanState["areaRespDanioID"] = 0;
    cleanState["areaRespRepaID"] = 0;
    cleanState["realizoPago"] = "NA";
  /*   cleanState["horaNombramiento"] = new Date();
    cleanState["horaAlimentos"] = new Date(); */

    InicializarInputs("reporteDaniosID", "Reporte de daños", "", 0, "Datos Generales", 0, "center");
    InicializarInputs("fechaElaboracion", "Fecha de Elaboración*", "", new Date(), "Datos Generales", 0, "center");
    InicializarInputs("nombrePoliza", "Nombre de Póliza*", "", "", "Datos Generales", 100);
    InicializarInputs("numIncidencia", "Número de acción*", "", "", "Datos Generales", 30);
    InicializarInputs("numNC", "Tipo de reclamación (Servicio no conforme, Daño a la carga, etc.)*", "", "", "Datos Generales", 30);
   /*  InicializarInputs("codigoClasifDanio", "Codigo Clasificacion Daño*", "", "", "Datos Generales", 30); */
    InicializarInputs("descripBreve", "Descripción Breve del Evento", "", "", "Datos Generales", 0);
    InicializarInputs("lugarEvento", "Lugar del Evento*", "", "", "Datos Generales", 0);
    InicializarInputs("semanaDanio", "Semana de Daño*", "", new Date(), "Datos Generales", 0, "center");
    InicializarInputs("fechaEvento", "Fecha del Evento*", "", new Date(), "Datos Generales", 0, "center");
    InicializarInputs("horaEvento", "Hora del Evento*", "", new Date(), "Datos Generales", 0, "center");
   // InicializarInputs("horasInvertidas", "Horas Invertidas", "", "0", "Datos Generales", 0, "center");
    InicializarInputs("supervCargo", "Supervisor(es) a Cargo Durante el Evento", "", "", "Datos Generales", 0);
    InicializarInputs("areaID", "Área", "", 0, "Datos Generales", 150);
    InicializarInputs("empresaID", "Empresa*", "", usuario["empresaID"], "Datos Generales", 0);
    InicializarInputs("danioOcasioTer", "Daño Ocasionado por un Tercero", "", "", "Datos Generales", 150);
    InicializarInputs("danioOcasioNos", "Daño Ocasionado por Nosotros", "", "", "Datos Generales", 150);
    InicializarInputs("montos", "Montos", "", "0", "Datos Generales", 0, "center");
    InicializarInputs("descripMedia", "Descripción del evento: (Incluir solo lo que pasó, cómo, cuándo, quién, testigos, maquinaria involucrada, etc.)", "", "", "Información del Evento", 0);
    InicializarInputs("danioOcasioA", "Daño Ocasionado a*", "", "", "Información del Evento", 150);
    InicializarInputs("tipoDanioOcasio", "Tipo de daño", "", "", "Información del Evento", 150);

    InicializarInputs("buqueViaje", "Buque viaje", "", "", "Información del Evento", 150);

    InicializarInputs("descripDetallada", "Descripción Detallada del Daño:", "Incluir descripción de los daños ocasionados que se presentan, partes o propiedad, ubicaciones, dimensiones, contenido, estatus, cantidad", "", "Información del Evento", 0);
    InicializarInputs("folioServicio", "Folio de servicio", "", "", "Información complementaria (en caso de aplicar)", 0);
    InicializarInputs("tipoServicio", "Tipo de servicio", "", "", "Información complementaria (en caso de aplicar)", 50);
    InicializarInputs("tipoMercancia", "¿Qué tipo de mercancia es?", "", "", "Información complementaria (en caso de aplicar)", 250);
    InicializarInputs("propiedadDe", "Propiedad de", "", "", "Información complementaria (en caso de aplicar)", 250);
    InicializarInputs("repreLocal", "Representante local", "", "", "Información complementaria (en caso de aplicar)", 250);
    InicializarInputs("fotografia1", "Foto (1)", "", "", "Incluir Fotografía(s) Ilustrativa(s) del Evento", 250);
    InicializarInputs("fotografia2", "Foto (2)", "", "", "Incluir Fotografía(s) Ilustrativa(s) del Evento", 250);
    InicializarInputs("nombresPersonal", "Nombres", "", "", "Información del Personal Involucrado", 0);
    InicializarInputs("numControlPersonal", "No. De control", "", "", "Información del Personal Involucrado", 0);
    InicializarInputs("habilidadBase", "Puesto o habilidad base", "", "", "Información del Personal Involucrado", 30);
    InicializarInputs("habilidadActiv", "Puesto o habilidad de la actividad que realizaba", "", "", "Información del Personal Involucrado", 150);
    InicializarInputs("fechaIngreso", "Fecha de Ingreso*", "", new Date(), "Información del Personal Involucrado", 0, "center");
    InicializarInputs("fechaHabilidad", "Fecha de habilidad*", "", new Date(), "Información del Personal Involucrado", 0, "center");
    InicializarInputs("otrosDaniosHabilidades", "Otros Daños o Habilidades", "", "", "Información del Personal Involucrado", 0);

    InicializarInputs("nombresTestigos", "Nombres", "", "", "Información de Testigo 1", 150);
    InicializarInputs("numControlTestigos", "No. De control", "", "", "Información de Testigo 1", 150);
    InicializarInputs("habilidadTestigos", "Puesto o habilidad", "", "", "Información de Testigo 1", 150);
    InicializarInputs("nombresTestigos2", "Nombres", "", "", "Información de Testigo 2", 150);
    InicializarInputs("numControlTestigos2", "No. De control", "", "", "Información de Testigo 2", 150);
    InicializarInputs("habilidadTestigos2", "Puesto o habilidad", "", "", "Información de Testigo 2", 150);
    InicializarInputs("notifAseg", "¿Fue necesaro notificar a nuestra aseguradora?", "", "", "", 5);
    InicializarInputs("reparaDanio", "¿Se acordó reparación del daño por parte de nosotros?", "", "", "", 5);
    InicializarInputs("inspecTerceros", "¿Se solicitó la inspección de una tercera parte?", "", "", "", 5);
    InicializarInputs("cotizacionDanio", "¿Se cuenta con Cotización del daño?", "", "", "", 5);
    InicializarInputs("anexRep", "¿Se anexan reportes internos / externos?", "", "", "", 5);
    InicializarInputs("quejaReclamacion", "¿Se cuenta con  queja y/o reclamación?", "", "", "", 5);
    InicializarInputs("reportesAnex", "¿Cuáles reportes se anexan?", "", "", "", 0);
    InicializarInputs("obserGenerales", "Observaciones Generales", "", "", "", 0);
    InicializarInputs("responAnalisis", "Responsable del Análisis de Causa Raíz", "", "", "", 0);
    //-----------------------------------------------------
    InicializarInputs("elaboro", "Elaboró", "", "", "", 250);
    InicializarInputs("firma", "Firma", "", "", "", 250);
    InicializarInputs("cargo", "Cargo", "", "", "", 0);
    //-----------------------------------------------------
    InicializarInputs("agencia", "Agencia *", "", "", "Datos de servicio al cliente general", 250, "left");
    InicializarInputs("cliente", "Cliente", "", "", "Datos de servicio al cliente general", 250, "left");
    InicializarInputs("formaRecibido", "Forma de recibido*", "(Correo, Teléfono)", "", "Datos de servicio al cliente general", 250, "left");
    InicializarInputs("armadora", "Armadora*", "", "", "Datos de servicio al cliente general", 100, "left");
    InicializarInputs("estatusCarga", "Estatus de carga*", "", "", "Datos de servicio al cliente general", 0, "left");
    InicializarInputs("datosCarga", "Datos de la carga", "Número de vin, contenedor", "", "Datos de servicio al cliente general", 50, "left");
    InicializarInputs("categoria", "Categoría*", "", "", "Datos de servicio al cliente general", 15, "left");
    InicializarInputs("estatusAccion", "Estatus de la acción", "", "", "Datos de servicio al cliente general", 250, "left");
    InicializarInputs("valorMercancia", "Valor de la mercancía", "", "0.00", "Datos de servicio al cliente general", 0, "right");
    InicializarInputs("montoReclamado", "Monto reclamado", "", "0.00", "Datos de servicio al cliente general", 0, "right");
    InicializarInputs("montoPagar", "Monto a pagar", "", "0.00", "Datos de servicio al cliente general", 0, "right");
    InicializarInputs("procede", "Procede", "", "", "Datos de servicio al cliente general", 2, "left");
    InicializarInputs("recibio", "Recibió (Quien recibió la reclamación)*", "", "", "Datos de servicio al cliente general", 250, "left");
    InicializarInputs("estatusReclamacion", "Estatus de la reclamación", "", "", "Datos de servicio al cliente general", 50, "left");
    InicializarInputs("numSiniestro", "Número de siniestro", "", 0, "Datos de servicio al cliente general", 0, "right");
    InicializarInputs("retroalimentacion", "Retroalimentación realizada", "", "", "Datos de servicio al cliente general", 250, "left");
    InicializarInputs("realizoPago", "¿Se realizó el pago?", "", "", "Datos de servicio al cliente general", 0, "right");
    InicializarInputs("pagoRealizado", "Pago realizado", "", "0.00", "Datos de servicio al cliente general", 0, "right");
    InicializarInputs("folioManiobras", "Folio de maniobras involucradas", "", "", "Datos de servicio al cliente general", 50, "left");
    InicializarInputs("montoManiobras", "Monto de las maniobras involucradas", "", "0.00", "Datos de servicio al cliente general", 0, "right");
    InicializarInputs("areaImputableID", "Área imputable", "", 0, "Datos de servicio al cliente general", 0, "left");


    InicializarInputs("ubicacion", "Ubicación del incidente / accidente", "Ubicación del incidente / accidente", "", "Servicio al cliente Autos", 0, "left");
    InicializarInputs("modeloUnidad", "Modelo de unidad (Marca, año, modelo)", "", "", "Servicio al cliente Autos", 50, "left");
    InicializarInputs("numVin", "Número de vin completo", "", "", "Servicio al cliente Autos", 50, "right");
    InicializarInputs("numControl", "Número de control", "", "", "Servicio al cliente Autos", 50, "left");
    InicializarInputs("nomChofer", "Nombre del chofer", "", "", "Servicio al cliente Autos", 250, "left");
    InicializarInputs("genero", "Género", "", "", "Servicio al cliente Autos", 10, "left");
    InicializarInputs("antiguedad", "Antigüedad de la categoría", "", "", "Servicio al cliente Autos", 250, "left");
    InicializarInputs("fechaNacimiento", "Fecha de nacimiento", "", "", "Servicio al cliente Autos", 0, "left");
    InicializarInputs("horaNombramiento", "Hora de nombramiento (Del día del incidente)", "", "", "Servicio al cliente Autos", 0, "left");
    InicializarInputs("turnoAnterior", "5 días anteriores de que turno andaba o sí descanso ", "", "", "Servicio al cliente Autos", 50, "left");
    InicializarInputs("horaAlimentos", "Hora de sus alimentos (Del día del incidente)", "", "", "Servicio al cliente Autos", 0, "left");
    InicializarInputs("calistenia", "Se brindó calistenia (Del día del incidente)", "", "", "Servicio al cliente Autos", 50, "left");
    InicializarInputs("ultimaPlatica", "Tema de la última plática de Seguridad", "", "", "Servicio al cliente Autos", 150, "left");
    InicializarInputs("fechaUltimaPlatica", "Fecha de la última plática de seguridad", "", "", "Servicio al cliente Autos", 0, "left");
    InicializarInputs("fechaRevProc", "Fecha en que se revisaron estos procedimientos con la persona", "", "", "Servicio al cliente Autos", 0, "left");


    //-----------------------------------------------------
    InputsConID["reporteDaniosID"].grid = { md: 3, lg: 3 };
    InputsConID["fechaElaboracion"].grid = { md: 3, lg: 3 };
    InputsConID["nombrePoliza"].grid = { md: 3, lg: 3 };
    InputsConID["numIncidencia"].grid = { md: 3, lg: 3 };
    //-----------------------------------------------------
    InputsConID["numNC"].grid = { md: 4, lg: 4 };
  /*   InputsConID["codigoClasifDanio"].grid = { md: 4, lg: 4 }; */
    InputsConID["lugarEvento"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["descripBreve"].grid = { md: 6, lg: 6 };
    InputsConID["semanaDanio"].grid = { md: 3, lg: 3 };
    InputsConID["fechaEvento"].grid = { md: 3, lg: 3 };
    //-----------------------------------------------------
    InputsConID["horaEvento"].grid = { md: 3, lg: 3 };
    //InputsConID["horasInvertidas"].grid = { md: 3, lg: 3 };
    //-----------------------------------------------------
    InputsConID["supervCargo"].grid = { md: 12, lg: 12 };
    //-----------------------------------------------------
    InputsConID["areaID"].grid = { md: 12, lg: 12 };
    //-----------------------------------------------------
    InputsConID["empresaID"].grid = { md: 6, lg: 6 };
    InputsConID["danioOcasioTer"].grid = { md: 6, lg: 6 };
    //-----------------------------------------------------
    InputsConID["danioOcasioNos"].grid = { md: 7, lg: 7 };
    InputsConID["montos"].grid = { md: 5, lg: 5 };
    //-----------------------------------------------------
    InputsConID["descripMedia"].grid = { md: 12, lg: 12 };
    //-----------------------------------------------------
    InputsConID["danioOcasioA"].grid = { md: 4, lg: 4 };
    InputsConID["tipoDanioOcasio"].grid = { md: 4, lg: 4 };
    InputsConID["buqueViaje"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["descripDetallada"].grid = { md: 12, lg: 12 };
    //-----------------------------------------------------
    InputsConID["folioServicio"].grid = { md: 4, lg: 4 };
    InputsConID["tipoServicio"].grid = { md: 4, lg: 4 };
    InputsConID["tipoMercancia"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["propiedadDe"].grid = { md: 6, lg: 6 };
    InputsConID["repreLocal"].grid = { md: 6, lg: 6 };
    //-----------------------------------------------------
    InputsConID["fotografia1"].grid = { md: 6, lg: 6 };
    InputsConID["fotografia2"].grid = { md: 6, lg: 6 };
    //-----------------------------------------------------
    InputsConID["nombresPersonal"].grid = { md: 8, lg: 8 };
    InputsConID["numControlPersonal"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["habilidadBase"].grid = { md: 6, lg: 6 };
    InputsConID["habilidadActiv"].grid = { md: 6, lg: 6 };
    //-----------------------------------------------------
    InputsConID["fechaIngreso"].grid = { md: 6, lg: 6 };
    InputsConID["fechaHabilidad"].grid = { md: 6, lg: 6 };
    //-----------------------------------------------------
    InputsConID["otrosDaniosHabilidades"].grid = { md: 12, lg: 12 };
    //-----------------------------------------------------
    InputsConID["nombresTestigos"].grid = { md: 4, lg: 4 };
    InputsConID["numControlTestigos"].grid = { md: 4, lg: 4 };
    InputsConID["habilidadTestigos"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["nombresTestigos2"].grid = { md: 4, lg: 4 };
    InputsConID["numControlTestigos2"].grid = { md: 4, lg: 4 };
    InputsConID["habilidadTestigos2"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["notifAseg"].grid = { md: 6, lg: 6 };
    InputsConID["reparaDanio"].grid = { md: 6, lg: 6 };
    //-----------------------------------------------------
    InputsConID["inspecTerceros"].grid = { md: 6, lg: 6 };
    InputsConID["cotizacionDanio"].grid = { md: 6, lg: 6 };
    //-----------------------------------------------------
    InputsConID["quejaReclamacion"].grid = { md: 4, lg: 4 };
    InputsConID["anexRep"].grid = { md: 4, lg: 4 };
    InputsConID["reportesAnex"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["obserGenerales"].grid = { md: 12, lg: 12 };
    InputsConID["responAnalisis"].grid = { md: 12, lg: 12 };
    //-----------------------------------------------------
    InputsConID["elaboro"].grid = { md: 4, lg: 4 };
    InputsConID["firma"].grid = { md: 4, lg: 4 };
    InputsConID["cargo"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------

    InputsConID["agencia"].grid = { md: 3, lg: 3 };
    InputsConID["cliente"].grid = { md: 3, lg: 3 };
    InputsConID["armadora"].grid = { md: 3, lg: 3 };
    InputsConID["formaRecibido"].grid = { md: 3, lg: 3 };
    //-----------------------------------------------------
    InputsConID["estatusCarga"].grid = { md: 3, lg: 3 };
    InputsConID["datosCarga"].grid = { md: 4, lg: 4 };
    InputsConID["categoria"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["estatusAccion"].grid = { md: 4, lg: 4 };
    InputsConID["valorMercancia"].grid = { md: 4, lg: 4 };
    InputsConID["montoReclamado"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["montoPagar"].grid = { md: 4, lg: 4 };
    InputsConID["procede"].grid = { md: 4, lg: 4 };
    InputsConID["recibio"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["estatusReclamacion"].grid = { md: 4, lg: 4 };
    InputsConID["numSiniestro"].grid = { md: 3, lg: 3 };
    InputsConID["retroalimentacion"].grid = { md: 3, lg: 3 };
    InputsConID["realizoPago"].grid = { md: 3, lg: 3 };
    //-----------------------------------------------------
    InputsConID["pagoRealizado"].grid = { md: 3, lg: 3 };
    InputsConID["folioManiobras"].grid = { md: 4, lg: 4 };
    InputsConID["montoManiobras"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["areaImputableID"].grid = { md: 4, lg: 4 };
    InputsConID["ubicacion"].grid = { md: 4, lg: 4 };
    InputsConID["modeloUnidad"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["numVin"].grid = { md: 4, lg: 4 };
    InputsConID["numControl"].grid = { md: 4, lg: 4 };
    InputsConID["nomChofer"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["genero"].grid = { md: 4, lg: 4 };
    InputsConID["antiguedad"].grid = { md: 4, lg: 4 };
    InputsConID["fechaNacimiento"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["horaNombramiento"].grid = { md: 4, lg: 4 };
    InputsConID["turnoAnterior"].grid = { md: 4, lg: 4 };
    InputsConID["horaAlimentos"].grid = { md: 4, lg: 4 };
    //-----------------------------------------------------
    InputsConID["calistenia"].grid = { md: 6, lg: 6 };
    InputsConID["ultimaPlatica"].grid = { md: 6, lg: 6 };
    InputsConID["fechaUltimaPlatica"].grid = { md: 5, lg: 5 };
    InputsConID["fechaRevProc"].grid = { md: 5, lg: 5 };
    //-----------------------------------------------------

    InputsConID["reporteDaniosID"].tipo = "select";
    InputsConID["reporteDaniosID"].data = stReporteDanios;

    InputsConID["empresaID"].tipo = "select";
    InputsConID["empresaID"].data = stEmpresas;

    InputsConID["descripBreve"].multiline = true;
    InputsConID["descripMedia"].multiline = true;
    InputsConID["descripDetallada"].multiline = true;

    let OpcionesDanios = [{ value: "A propiedad interna", label: "A propiedad interna" },
    { value: "A la carga", label: "A la carga" },
    { value: "A un tercero (Externo)", label: "A un tercero (Externo)" }
    ];

    InputsConID["danioOcasioTer"].tipo = "select";
    InputsConID["danioOcasioTer"].data = OpcionesDanios;

    InputsConID["danioOcasioNos"].tipo = "select";
    InputsConID["danioOcasioNos"].data = OpcionesDanios;

    let OpcionesDanioA = [{ value: "Carga General", label: "Carga General" },
    { value: "Contenedor (es)", label: "Contenedor (es)" },
    { value: "Automóvil (es)", label: "Automóvil (es)" },
    { value: "Maquinaria y/o Equipo Interno", label: "Maquinaria y/o Equipo Interno" },
    { value: "Herramientas de Trabajo", label: "Herramientas de Trabajo" },
    { value: "Instalaciones", label: "Instalaciones" },
    { value: "Propiedad Externa", label: "Propiedad Externa" }
    ];

    InputsConID["danioOcasioA"].tipo = "select";
    InputsConID["danioOcasioA"].data = OpcionesDanioA;
    InputsConID["danioOcasioA"].value = stDatos["danioOcasioA"];

    InputsConID["tipoDanioOcasio"].title = stTituloTipoDanio;
    InputsConID["tipoDanioOcasio"].placeholder = stTituloTipoDanio;

    let OpcionesMercancia = [{ value: "Importacion", label: "Importacion" },
    { value: "Exportación", label: "Exportación" },
    { value: "Vacios", label: "Vacios" },
    { value: "Transbordo Lleno", label: "Transbordo Lleno" },
    { value: "Transbordo Vacío", label: "Transbordo Vacío" },
    { value: "NA", label: "NA" }
    ];

    InputsConID["tipoMercancia"].tipo = "select";
    InputsConID["tipoMercancia"].data = OpcionesMercancia;

    let Opciones = [{ value: "SI", label: "SI" },
    { value: "NO", label: "NO" },
    { value: "NA", label: "NA" }
    ];

    InputsConID["notifAseg"].tipo = "select";
    InputsConID["notifAseg"].data = Opciones;

    InputsConID["quejaReclamacion"].tipo = "select";
    InputsConID["quejaReclamacion"].data = Opciones;

    InputsConID["realizoPago"].tipo = "select";
    InputsConID["realizoPago"].data = Opciones;

    InputsConID["reparaDanio"].tipo = "select";
    InputsConID["reparaDanio"].data = Opciones;

    InputsConID["inspecTerceros"].tipo = "select";
    InputsConID["inspecTerceros"].data = Opciones;

    InputsConID["cotizacionDanio"].tipo = "select";
    InputsConID["cotizacionDanio"].data = Opciones;

    InputsConID["anexRep"].tipo = "select";
    InputsConID["anexRep"].data = Opciones;

    InputsConID["fotografia1"].tipo = "imageupload";
    InputsConID["fotografia1"]["removeImage"] = stDatos["fotografia1"] === "" ? true : false;
    InputsConID["fotografia1"].onChange = (file, base) => {
        if (file === null) {
            remover = true;
        }
        setState(stDatos => ({
            ...stDatos,
            'fotografia1': base
        }));

        if (open) {
            setFotografia1({ valor: base, file: file, eliminar: remover });
        }
        return;
    };
    InputsConID["fotografia2"].tipo = "imageupload";
    InputsConID["fotografia2"]["removeImage"] = stDatos["fotografia2"] === "" ? true : false;
    InputsConID["fotografia2"].onChange = (file, base) => {
        if (file === null) {
            remover = true;
        }
        setState(stDatos => ({
            ...stDatos,
            'fotografia2': base
        }));
        if (open) {
            setFotografia2({ valor: base, file: file, eliminar: remover });
        }
        return;
    };

    InputsConID["fechaElaboracion"].tipo = "datetimepicker";
    InputsConID["fechaElaboracion"].timeFormat = false;
    InputsConID["fechaElaboracion"].onlyDate = true;
    InputsConID["fechaElaboracion"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "fechaElaboracion");
    };

    InputsConID["semanaDanio"].tipo = "datetimepicker";
    InputsConID["semanaDanio"].timeFormat = false;
    InputsConID["semanaDanio"].onlyDate = true;
    InputsConID["semanaDanio"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "semanaDanio");
    };

    InputsConID["fechaIngreso"].tipo = "datetimepicker";
    InputsConID["fechaIngreso"].timeFormat = false;
    InputsConID["fechaIngreso"].onlyDate = true;
    InputsConID["fechaIngreso"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "fechaIngreso");
    };

    InputsConID["fechaHabilidad"].tipo = "datetimepicker";
    InputsConID["fechaHabilidad"].timeFormat = false;
    InputsConID["fechaHabilidad"].onlyDate = true;
    InputsConID["fechaHabilidad"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "fechaHabilidad");
    };

    InputsConID["fechaEvento"].tipo = "datetimepicker";
    InputsConID["fechaEvento"].timeFormat = false;
    InputsConID["fechaEvento"].onlyDate = true;
    InputsConID["fechaEvento"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "fechaEvento");
    };

    InputsConID["horaEvento"].tipo = "datetimepicker";
    InputsConID["horaEvento"].timeFormat = false;
    InputsConID["horaEvento"].onlyTime = true;
    InputsConID["horaEvento"].onlyDate = false;
    InputsConID["horaEvento"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "horaEvento");
    };

    InputsConID["areaImputableID"].tipo = "select";
    InputsConID["areaImputableID"].data = seleccionables.Areas;

    InputsConID["areaID"].tipo = "select";
    InputsConID["areaID"].data = seleccionables.Areas;

    //InputsConID["horasInvertidas"].onChange = ({ target: { value } }) => !isNaN(Number(value)) && handleChange(value, "horasInvertidas");

    InputsConID["montos"].onChange = ({ target: { value } }) => !isNaN(Number(value)) && handleChange(value, "montos");


    /*let OpcionesFormaRecibido = [
        { value: "Correo", label: "Correo" },
        { value: "Teléfono", label: "Teléfono" }
    ];

    InputsConID["formaRecibido"].tipo = "select";
    InputsConID["formaRecibido"].data = OpcionesFormaRecibido;*/

    let OpcionesEstatusCarga = [
        { value: "Se embarcó", label: "Se embarcó" },
        { value: "Desistió", label: "Desistió" }
    ];

    InputsConID["estatusCarga"].tipo = "select";
    InputsConID["estatusCarga"].data = OpcionesEstatusCarga;

    let OpcionesCategoria = [
        { value: "Exportación", label: "Exportación" },
        { value: "Importación", label: "Importación" }
    ];

    InputsConID["categoria"].tipo = "select";
    InputsConID["categoria"].data = OpcionesCategoria;

    InputsConID["procede"].tipo = "select";
    InputsConID["procede"].data = Opciones;

    InputsConID["calistenia"].tipo = "select";
    InputsConID["calistenia"].data = Opciones;

    let OpcionesGenero = [
        { value: "Masculino", label: "Masculino" },
        { value: "Femenino", label: "Femenino" }
    ];

    InputsConID["genero"].tipo = "select";
    InputsConID["genero"].data = OpcionesGenero;

    InputsConID["fechaNacimiento"].tipo = "datetimepicker";
    InputsConID["fechaNacimiento"].timeFormat = false;
    InputsConID["fechaNacimiento"].onlyDate = true;
    InputsConID["fechaNacimiento"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "fechaNacimiento");
    };

    InputsConID["fechaUltimaPlatica"].tipo = "datetimepicker";
    InputsConID["fechaUltimaPlatica"].timeFormat = false;
    InputsConID["fechaUltimaPlatica"].onlyDate = true;
    InputsConID["fechaUltimaPlatica"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "fechaUltimaPlatica");
    };

    InputsConID["fechaRevProc"].tipo = "datetimepicker";
    InputsConID["fechaRevProc"].timeFormat = false;
    InputsConID["fechaRevProc"].onlyDate = true;
    InputsConID["fechaRevProc"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "fechaRevProc");
    };

    InputsConID["horaNombramiento"].tipo = "datetimepicker";
    InputsConID["horaNombramiento"].timeFormat = false;
    InputsConID["horaNombramiento"].onlyTime = true;
    InputsConID["horaNombramiento"].onlyDate = false;
    InputsConID["horaNombramiento"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "horaNombramiento");
    };

    InputsConID["horaAlimentos"].tipo = "datetimepicker";
    InputsConID["horaAlimentos"].timeFormat = false;
    InputsConID["horaAlimentos"].onlyTime = true;
    InputsConID["horaAlimentos"].onlyDate = false;
    InputsConID["horaAlimentos"].onChange = (value) => {
        if (typeof value !== "object") return;
        handleChange(value, "horaAlimentos");
    };

    InputsConID["valorMercancia"].textAlign = "right";
    InputsConID["valorMercancia"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["valorMercancia"].posicionIcono = "start";
    InputsConID["valorMercancia"].formatoImportes = true;

    InputsConID["montoReclamado"].textAlign = "right";
    InputsConID["montoReclamado"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["montoReclamado"].posicionIcono = "start";
    InputsConID["montoReclamado"].formatoImportes = true;

    InputsConID["montoPagar"].textAlign = "right";
    InputsConID["montoPagar"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["montoPagar"].posicionIcono = "start";
    InputsConID["montoPagar"].formatoImportes = true;

    InputsConID["pagoRealizado"].textAlign = "right";
    InputsConID["pagoRealizado"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["pagoRealizado"].posicionIcono = "start";
    InputsConID["pagoRealizado"].formatoImportes = true;

    InputsConID["montoManiobras"].textAlign = "right";
    InputsConID["montoManiobras"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["montoManiobras"].posicionIcono = "start";
    InputsConID["montoManiobras"].formatoImportes = true;

    InputsConID["montos"].textAlign = "right";
    InputsConID["montos"].icono = <IconoSimbolo simbolo="$" />;
    InputsConID["montos"].posicionIcono = "start";
    InputsConID["montos"].formatoImportes = true;

    Secciones["Servicio al cliente Autos"].hide = (stDatos["danioOcasioA"] !== "Automóvil (es)");

    function DisabledAllInputs() {
        for (const key in InputsConID) {
            InputsConID[key].disabled = stDatos["finalizado"] === 1 ? true : false;
        }
    }

    const Auto = [
        'ubicacion',
        'modeloUnidad',
        'numVin',
        'numControl',
        'nomChofer',
        'genero',
        'antiguedad',
        'fechaNacimiento',
        'horaNombramiento',
        'turnoAnterior',
        'horaAlimentos',
        'calistenia',
        'ultimaPlatica',
        'fechaUltimaPlatica',
        'fechaRevProc'
    ]

     function VerificarAuto()
    {

        stDatos['danioOcasioA'] == "Automóvil (es)"?
        Auto.map(key =>
            {
                InputsConID[key].disabled = false;
            }) :
            Auto.map(key =>
                {
                    InputsConID[key].value = "";
                    InputsConID[key].disabled = true;
                })
    }



                DisabledAllInputs();
                VerificarAuto();





    function InicializarInputs(Identificador, pTitulo = "", pPlaceholder = "", ValorInicial = "", Seccion = "", MaxLength = 0, textAlign = 'left') {

        cleanErrorState[Identificador] = { error: false, helperText: "" };
        cleanState[Identificador] = ValorInicial;
        ArrayRef[Identificador] = useRef(null);

        if (pTitulo === "") {
            pTitulo = Identificador;
        }

        if (pPlaceholder === "") {
            pPlaceholder = pTitulo;
        }

        let tInput = {
            value: stDatos[Identificador],
            id: Identificador,
            error: errorState[Identificador].error,
            success: stDatos[Identificador] && !errorState[Identificador].error ? true : undefined,
            helperText: errorState[Identificador].helperText,
            inputRef: ArrayRef[Identificador],
            title: pTitulo,
            placeholder: pPlaceholder,
            textAlign: textAlign,
            onChange: ({ target: { value } }) => handleChange(value, Identificador, MaxLength),
            onKeyDown: () => { return; }
        };

        InputsConID[Identificador] = tInput;
        if (Seccion === "") {
            inputs.push(tInput);
            return;
        }

        let tInputsDeSeccion = [];
        let InputFieldSet;
        if (Secciones[Seccion]) {
            InputFieldSet = Secciones[Seccion];
            tInputsDeSeccion = InputFieldSet.inputs;
        } else {
            InputFieldSet = {
                id: Seccion,
                leyenda: Seccion,
                placeholder: Seccion,
                tipo: "fieldset",
                sizeLetra: "1.5em",
                widthBorderFieldset:  Seccion === "Datos de servicio al cliente general" ? "10px" : "1px",
                fontWeight: Seccion === "Datos de servicio al cliente general" ? 700 : 300
            };
            

            inputs.push(InputFieldSet);
        }

        tInputsDeSeccion.push(tInput);
        InputFieldSet.inputs = tInputsDeSeccion;
        Secciones[Seccion] = InputFieldSet;
    }

    let accionesFormulario = [{
        loader,
        disabled,
        icono: SaveIcon,
        color: info,
        descripcion: "Guardar",
        onClick: () => handleGuardar({
            setLoader,
            setDisabled,
            setActualizar,
            actualizar,
            setNotificaciones,
            handleClose,
            handleFocus,
            refFocus: ArrayRef["fechaElaboracion"],
            mensajeCorrecto: `El reporte de servicio a clientes se ${stDatos["reporteDaniosCliID"] ? "actualizó" : "agregó"} correctamente`,
            asyncCallback: ftGuardar,
        }),
        // inputRef: accederRef,
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleClose
    }];

    function ftErrorInputText({ condicion, ref, keyError, mensajeError }) {
        return handleErrorInputText({
            cleanErrorState,
            condicion,
            ref,
            keyError,
            mensajeError,
            loader: setLoader,
            disabled: setDisabled,
            errorState: setErrorState
        });
    }

    function handleValidaciones() {

        let error;
        let validaciones = [
        {
            condicion: !stDatos["nombrePoliza"] || trim(stDatos["nombrePoliza"]) === "",
            ref: ArrayRef["nombrePoliza"],
            keyError: "nombrePoliza",
            mensajeError: "Debe especificar el Nombre de la Póliza"
        },
        {
            condicion: !stDatos["numIncidencia"] || trim(stDatos["numIncidencia"]) === "",
            ref: ArrayRef["numIncidencia"],
            keyError: "numIncidencia",
            mensajeError: "Debe especificar el No. de Acción"
        },
        {
            condicion: !stDatos["numNC"] || trim(stDatos["numNC"]) === "",
            ref: ArrayRef["numNC"],
            keyError: "numNC",
            mensajeError: "Debe especificar el No. De NC"
        },
        {
            condicion: !stDatos["empresaID"] || ["empresaID"] === 0,
            ref: ArrayRef["empresaID"],
            keyError: "empresaID",
            mensajeError: "Debe especificar la empresa"
        },
        {
            condicion: !stDatos["fechaElaboracion"] || trim(stDatos["fechaElaboracion"]) === "",
            ref: ArrayRef["fechaElaboracion"],
            keyError: "fechaElaboracion",
            mensajeError: "Debe especificar la fecha de elaboración"
        },
        {
            condicion: !stDatos["lugarEvento"] || trim(stDatos["lugarEvento"]) === "",
            ref: ArrayRef["lugarEvento"],
            keyError: "lugarEvento",
            mensajeError: "Debe especificar el lugar del evento"
        },
        {
            condicion: !stDatos["semanaDanio"] || trim(stDatos["semanaDanio"]) === "",
            ref: ArrayRef["semanaDanio"],
            keyError: "semanaDanio",
            mensajeError: "Debe especificar la semana del daño"
        },
        {
            condicion: !stDatos["fechaIngreso"] || trim(stDatos["fechaIngreso"]) === "",
            ref: ArrayRef["fechaIngreso"],
            keyError: "fechaIngreso",
            mensajeError: "Debe especificar la fecha de ingreso"
        },
        {
            condicion: !stDatos["fechaHabilidad"] || trim(stDatos["fechaHabilidad"]) === "",
            ref: ArrayRef["fechaHabilidad"],
            keyError: "fechaHabilidad",
            mensajeError: "Debe especificar la fecha de habilidad"
        },
        {
            condicion: !stDatos["fechaEvento"] || trim(stDatos["fechaEvento"]) === "",
            ref: ArrayRef["fechaEvento"],
            keyError: "fechaEvento",
            mensajeError: "Debe especificar la fecha del evento"
        },
        {
            condicion: !stDatos["horaEvento"] || trim(stDatos["horaEvento"]) === "",
            ref: ArrayRef["horaEvento"],
            keyError: "horaEvento",
            mensajeError: "Debe especificar la hora del evento"
        },
        /*stDatos["horasInvertidas"] !== "" && {
            condicion: !rgxdeInt2.test(stDatos["horasInvertidas"]),
            ref: ArrayRef["horasInvertidasRef"],
            keyError: "horasInvertidas",
            mensajeError: "El formato de la hora es inválido"
        },*/
        {
            condicion: !stDatos["danioOcasioA"] || trim(stDatos["danioOcasioA"]) === "",
            ref: ArrayRef["danioOcasioA"],
            keyError: "danioOcasioA",
            mensajeError: "Debe especificar el daño Ocasionado a"
        },
        {
            condicion: !stDatos["agencia"] || trim(stDatos["agencia"]) === "",
            ref: ArrayRef["agencia"],
            keyError: "agencia",
            mensajeError: "Debe especificar la Agencia"
        },
        {
            condicion: !stDatos["formaRecibido"] || trim(stDatos["formaRecibido"]) === "",
            ref: ArrayRef["formaRecibido"],
            keyError: "formaRecibido",
            mensajeError: "Debe especificar la forma de recibido"
        },
        {
            condicion: !stDatos["armadora"] || trim(stDatos["armadora"]) === "",
            ref: ArrayRef["armadora"],
            keyError: "armadora",
            mensajeError: "Debe especificar la Armadora"
        },
        {
            condicion: !stDatos["estatusCarga"] || trim(stDatos["estatusCarga"]) === "",
            ref: ArrayRef["estatusCarga"],
            keyError: "estatusCarga",
            mensajeError: "Debe especificar el Estatus de carga"
        },
        {
            condicion: !stDatos["categoria"] || trim(stDatos["categoria"]) === "",
            ref: ArrayRef["categoria"],
            keyError: "categoria",
            mensajeError: "Debe especificar la categoría"
        },
        {
            condicion: !stDatos["recibio"] || trim(stDatos["recibio"]) === "",
            ref: ArrayRef["recibio"],
            keyError: "recibio",
            mensajeError: "Debe especificar quien recibió la reclamación"
        }/* ,
        {
            condicion: (!stDatos["horaNombramiento"] || trim(stDatos["horaNombramiento"]) === "" && stDatos['danioOcasioA'] == "Automóvil (es)"),
            ref: ArrayRef["horaNombramiento"],
            keyError: "horaNombramiento",
            mensajeError: "Debe especificar la hora del nombramiento"
        },
        {
                condicion: (!stDatos["horaAlimentos"] || trim(stDatos["horaAlimentos"]) === "") && stDatos['danioOcasioA'] == "Automóvil (es)",
                ref: ArrayRef["horaAlimentos"],
                keyError: "horaAlimentos",
                mensajeError: "Debe especificar la hora de alimentos"
            }, */
        ];

        validaciones.forEach(({ condicion, ref, keyError, mensajeError }) => {
            if (stDatos["reporteDaniosCliID"] === 0) {
                if (error) return;
                error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
            } else {
                if (error) return;
                error = ftErrorInputText({ condicion, ref, keyError, mensajeError });
            }
        });

        if (error) return error;
    }

    function ftGuardar() {
        async function ftGuardar() {
            let valor;
            let error = await handleValidaciones();
            //try{
            let DatosGuardar = { ...stDatos };
            DatosGuardar["fechaElaboracion"] = formatearFecha(DatosGuardar["fechaElaboracion"]);
            DatosGuardar["semanaDanio"] = formatearFecha(DatosGuardar["semanaDanio"]);
            DatosGuardar["fechaIngreso"] = formatearFecha(DatosGuardar["fechaIngreso"]);
            DatosGuardar["fechaHabilidad"] = formatearFecha(DatosGuardar["fechaHabilidad"]);
            DatosGuardar["fechaEvento"] = formatearFecha(DatosGuardar["fechaEvento"]);
            DatosGuardar["horaEvento"] = formatearHora(DatosGuardar["horaEvento"]);
           // DatosGuardar["horasInvertidas"] = DatosGuardar["horasInvertidas"] ? parseFloat(DatosGuardar["horasInvertidas"]) : 0
            DatosGuardar["montos"] = DatosGuardar["montos"] ? parseFloat(DatosGuardar["montos"]) : 0
            DatosGuardar["costoDanio"] = parseFloat(DatosGuardar["costoDanio"]);
            DatosGuardar["reporteDaniosCliID"] = parseInt(DatosGuardar["reporteDaniosCliID"]);
            DatosGuardar["finalizado"] = parseInt(DatosGuardar["finalizado"])

            DatosGuardar["areaImputableID"] = parseInt(DatosGuardar["areaImputableID"]);
            DatosGuardar["areaID"] = parseInt(DatosGuardar["areaID"])


            DatosGuardar["valorMercancia"] = parseFloat(DatosGuardar["valorMercancia"]);
            DatosGuardar["montoReclamado"] = parseFloat(DatosGuardar["montoReclamado"]);
            DatosGuardar["montoPagar"] = parseFloat(DatosGuardar["montoPagar"]);
            DatosGuardar["pagoRealizado"] = parseFloat(DatosGuardar["pagoRealizado"]);
            DatosGuardar["montoManiobras"] = parseFloat(DatosGuardar["montoManiobras"]);
            DatosGuardar["areaRespDanioID"] = parseInt(DatosGuardar["areaRespDanioID"]);
            DatosGuardar["areaRespRepaID"] = parseInt(DatosGuardar["areaRespRepaID"]);
            DatosGuardar["numSiniestro"] = parseInt(DatosGuardar["numSiniestro"]);


            DatosGuardar["areaID"] = parseInt(DatosGuardar["areaID"]);
            DatosGuardar["areaRespDanioID"] = parseInt(DatosGuardar["areaRespDanioID"]);
            DatosGuardar["areaRespRepaID"] = parseInt(DatosGuardar["areaRespRepaID"]);

            DatosGuardar["ubicacion"] = stDatos['danioOcasioA'] === "Automóvil (es)" && stDatos['ubicacion']  !== (null || "") ? DatosGuardar["ubicacion"] : null;

            DatosGuardar["fechaNacimiento"] = stDatos['danioOcasioA'] === "Automóvil (es)" && stDatos['fechaNacimiento'] !== (null || "")? formatearFecha(DatosGuardar["fechaNacimiento"]) : null;

            DatosGuardar["fechaUltimaPlatica"] = stDatos['danioOcasioA'] === "Automóvil (es)" && stDatos['fechaUltimaPlatica'] !== (null || "")? formatearFecha(DatosGuardar["fechaUltimaPlatica"]) : null;

            DatosGuardar["fechaRevProc"] = stDatos['danioOcasioA'] === "Automóvil (es)" && stDatos['fechaRevProc'] !== (null || "")? formatearFecha(DatosGuardar["fechaRevProc"]) : null;

            DatosGuardar["horaAlimentos"] = stDatos['danioOcasioA'] === "Automóvil (es)" && stDatos['horaAlimentos'] !== (null || "")? formatearHora(DatosGuardar["horaAlimentos"]) : null;

            DatosGuardar["horaNombramiento"] = stDatos['danioOcasioA'] === "Automóvil (es)" && stDatos['horaNombramiento'] !== (null || "")? formatearHora(DatosGuardar["horaNombramiento"]) : null;

            if (error) return error;

            let datos = { serverStorageID: stDatos.storageID1, origenID: Number(DatosGuardar.reporteDaniosCliID), tabla: "REPORTEDANIOSCLIENTES", tipo: "REPORTEDANIOSCLIENTES", clasificacion: "fotoDanio", nombreArchivo: stFotografia1.eliminar ? "" : stFotografia1.file.name, ruta: stDatos["rutafotografia1"] }

            let datos2 = { serverStorageID: stDatos.storageID2, origenID: Number(DatosGuardar.reporteDaniosCliID), tabla: "REPORTEDANIOSCLIENTES", tipo: "REPORTEDANIOSCLIENTES", clasificacion: "fotoDanio", nombreArchivo: stFotografia2.eliminar ? "" : stFotografia2.file.name, ruta: stDatos["rutafotografia2"] }

            delete DatosGuardar["fotografia1"];
            delete DatosGuardar["rutafotografia1"];
            delete DatosGuardar["storageID1"];
            delete DatosGuardar["nombrefoto1"];

            delete DatosGuardar["fotografia2"];
            delete DatosGuardar["rutafotografia2"];
            delete DatosGuardar["storageID2"];
            delete DatosGuardar["nombrefoto2"];
            delete DatosGuardar["fechaModificacion"];
            delete DatosGuardar["folioInterno"];
            delete DatosGuardar["areaNombre"];
            delete DatosGuardar["areaRespRepaNombre"];
            delete DatosGuardar["areaRespDanioNombre"];
            delete DatosGuardar["horasInvertidas"];
            delete DatosGuardar["ubicacionID"];
            delete DatosGuardar["ejercicio"];
            delete DatosGuardar["mes"];
            delete DatosGuardar["fechaInicio"];
            delete DatosGuardar["fechaFin"];
            delete DatosGuardar["fechaFinReporte"];

            if (stDatos["reporteDaniosCliID"]) {
                await Consultas.updateReporteDaniosClientes(DatosGuardar, token);
            } else {
                delete DatosGuardar["reporteDaniosCliID"];
                valor = await Consultas.addReporteDaniosClientes(DatosGuardar, token);
                datos = { ...datos, serverStorageID: null, origenID: valor.reporteDaniosCliID };
                datos2 = { ...datos2, serverStorageID: null, origenID: valor.reporteDaniosCliID };
            }
            try {
                if (stFotografia1.file || stFotografia1.eliminar == true) {
                    await actualizaArchivo('ReporteDaniosClientes/fotoPerfil/', stFotografia1.file, 1, datos, token, stFotografia1.eliminar);
                }
                if (stFotografia2.file || stFotografia2.eliminar == true) {
                    await actualizaArchivo('ReporteDaniosClientes/fotoPerfil/', stFotografia2.file, 1, datos2, token, stFotografia2.eliminar);
                }
            } catch (error) {
                setNotificaciones({ mensaje: error, color: danger, open: true });
            }
        }

        return ftGuardar();
    }

    function formatearFecha(pFecha) {
        if (moment(pFecha).isValid() === false) {
            return null;
        }

        let formatoFecha = "YYYY-MM-DD";
        return moment(pFecha).format(formatoFecha);
    }

    function formatearHora(pHora) {
        if (moment(pHora).isValid() === false) {
            let tHora = moment(pHora, 'HH:mm').format('HH:mm');
            if (moment(tHora).isValid() === false) {
                return tHora;
            }
            return null;
        }

        return moment(pHora).format("HH:mm");
    }

    function handleClose() {
        setOpen(false);
        setDisabled(false);
        setLoader(false);
        setNotificaciones({ ...cleanNotificaciones });
        setState({ ...cleanState });
        setFotografia1({ valor: "", file: "", remover: false });
        setFotografia2({ valor: "", file: "", remover: false });
        setErrorState({ ...cleanErrorState });
    }

    function handleChange(value, key, MaxLength = 0) {
        if (key === "fotoUsuario") {
            return;
        }

        if (value.length > MaxLength && MaxLength !== 0) {
            return;
        }

        if (key === "costoDanio"
            || key === "valorMercancia"
            || key === "montoReclamado"
            || key === "montoPagar"
            || key === "pagoRealizado"
            || key === "montoManiobras") {
            if (isNaN(Number(value))) {
                return;
            }
        }

        if (key === "reporteDaniosID") {
            AsignarValoresDesdeReporteDanios(value);
        }
        setState(stDatos => ({
            ...stDatos,
            [key]: value
        }));

        setErrorState(errorState => ({
            ...errorState,
            [key]: { helperText: "", error: false }
        }));


        if (key === "danioOcasioA") {
            switch (value) {
                case "Carga General":
                    setTituloTipoDanio("Tipo de Carga y/o No. de Serie");
                    setErrorState({...errorState});
                    break;
                case "Contenedor (es)":
                    setTituloTipoDanio("Tipo y No de Cont.");
                    break;
                case "Automóvil (es)":
                    setTituloTipoDanio("No. Serie");

                    break;
                case "Maquinaria y/o Equipo Interno":
                    setTituloTipoDanio("No. de Serie y/o Económico");
                    break;
                case "Herramientas de Trabajo":
                    setTituloTipoDanio("Tipo de Herramienta");
                    break;
                case "Instalaciones":
                    setTituloTipoDanio("¿Cuál (es)?");
                    break;
                case "Propiedad Externa":
                    setTituloTipoDanio("Tipo y No de Serie o Económico");
                    break;
                default:
                    setTituloTipoDanio("")
                    break;
            }
        }
    }

    async function ObtenerEmpresas() {
        let Respuesta = await ConsultasEmpresas.seleccionEmpresa({ filtro: { activa: 1 } }, token);
        setEmpresas(Respuesta);
    }

    async function ObtenerReporteDanios() {
        let Respuesta = await ConsultasReporteDanios.seleccionReporteDanios({ filtro: {} }, token);
        setReporteDanios(Respuesta);
    }

    async function AsignarValoresDesdeReporteDanios(pReporteDaniosID) {
        for (let i = 0; i < stReporteDanios.length; i++) {
            let tElement = stReporteDanios[i];
            if (parseInt(pReporteDaniosID) === parseInt(tElement.value)) {

                let Registro = await ConsultasReporteDanios.getReporteDanios({ reporteDaniosID: pReporteDaniosID }, token);

                if (Registro.fotografia1 !== "") {
                    let file1 = await dataUrlToFile(Registro.fotografia1, Registro.reporteDaniosID + "foto1")
                    setFotografia1({ valor: Registro.fotografia1, file: file1, remover: true });
                }

                if (Registro.fotografia2 !== "") {
                    let file2 = await dataUrlToFile(Registro.fotografia2, Registro.reporteDaniosID + "foto2")
                    setFotografia2({ valor: Registro.fotografia2, file: file2, remover: true });
                }

                setState(stDatos => ({
                    ...stDatos,
                    ...Registro,
                    storageID1: null,
                    storageID2: null,
                    finalizado: 0,
                    ubicacion: ''
                }));
                return;
            }
        }
    }

    async function dataUrlToFile(dataUrl, fileName) {
        const res = await fetch(dataUrl);
        const blob = await res.blob();
        return new File([blob], fileName, { type: 'image/png' });
    }

    useEffect(() => {
        async function ftEffect() {
            try {
                ObtenerEmpresas();
                ObtenerReporteDanios();

                let Areas = await seleccionArea({ filtro: {} }, token);
                let Ubicaciones = await seleccionUbicaciones({ filtro: {} }, token);
                setSeleccionables({ Areas, Ubicaciones });

            } catch ({ message }) {
                setAlert({
                    descripcion: `Algunos datos necesarios para funcionar no se cargaron correctamente, intenta actualizar la página o verifica tu conexión a internet; a continuación se muestrán más detalles del error: ${NetworkError(message)}`,
                    title: "¡Una disculpa!",
                    tipo: danger,
                    msjConfirmacion: "Aceptar",
                    onConfirm: () => setAlert(null)
                });
            }
        }
        ftEffect();
    }, []);


    function handleCloseSeguimiento() {
        setAbrirSeguimiento(false);
        setnotificacionesSeguimiento({ ...cleanNotificaciones });
        setseguimientoSelect("");
    }

    ArrayRef["seguimientoSelect"] = useRef(null);
    cleanErrorState["seguimientoSelect"] = { error: false, helperText: "" };

    const inputsSeguimiento = [{
        value: seguimientoSelect,
        id: "seguimientoSelect",
        error: errorState["seguimientoSelect"].error,
        success: seguimientoSelect && !errorState["seguimientoSelect"].error ? true : undefined,
        helperText: errorState["seguimientoSelect"].helperText,
        inputRef: ArrayRef["seguimientoSelect"],
        title: "Seguimiento",
        placeholder: "Seguimiento",
        textAlign: "left",
        onChange: ({ target: { value } }) => setseguimientoSelect(value),
        onKeyDown: () => { return; },
        grid: { md: 12, lg: 12 },
        tipo: "select",
        data: [{ value: "SIN RECLAMACIÓN", label: "SIN RECLAMACIÓN" },
        { value: "REPARADO", label: "REPARADO" },
        { value: "PAGADO", label: "PAGADO" },
        { value: "RECLAMADO A ASEGURADORA (RGR-002)", label: "RECLAMADO A ASEGURADORA (RGR-002)" },
        { value: "RECLAMADO A TERCERO (RGR-007)", label: "RECLAMADO A TERCERO (RGR-007)" }
        ]
    }]

    const accionesSeguimiento = [{
        loader,
        disabled,
        icono: AssignmentTurnedInIcon,
        color: info,
        descripcion: "Cerrar reporte",
        onClick: () => CerrarReporte()
    }, {
        disabled,
        icono: Close,
        color: danger,
        descripcion: "Cancelar",
        onClick: handleCloseSeguimiento
    }];

    function AbrirFormCerrarReporte(parametros) {
        setCerrarReporte(parametros)
        if (parametros.estatus === "CERRADO") {
            setAlert({
                descripcion: 'El reporte de servicio a clientes ya se encuentra cerrado',
                title: "Cerrar reporte",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null),
                msjCancelacion: "Cancelar",
                onCancel: () => setAlert(null)
            });
            return;
        }

        setAbrirSeguimiento(true);
    }

    async function CerrarReporte() {
        try {
            let result = await Consultas.CerrarReporteDaniosClientes({ reporteDaniosCliID: stCerrarReporte['reporteDaniosCliID'], seguimiento: seguimientoSelect }, token);

            switch (seguimientoSelect) {
                case "RECLAMADO A ASEGURADORA (RGR-002)":
                    setAlert({
                        descripcion: 'El reporte de servicio a clientes generó la reclamación a aseguradora con No. Siniestro ' + stCerrarReporte.folio,
                        title: "",
                        tipo: "success-two",
                        msjConfirmacion: "Abrir reclamo",
                        onConfirm: () => IrARuta('ASEGURADORA', result["RegistroID"]),
                        msjCancelacion: "Cancelar",
                        onCancel: () => setAlert(null)
                    });
                    break;
                case "RECLAMADO A TERCERO (RGR-007)":
                    setAlert({
                        descripcion: 'El reporte de servicio a clientes generó la reclamación a tercero con No. Siniestro ' + stCerrarReporte.folio,
                        title: "",
                        tipo: "success-two",
                        msjConfirmacion: "Abrir reclamo",
                        onConfirm: () => IrARuta('TERCERO', result["RegistroID"]),
                        msjCancelacion: "Cancelar",
                        onCancel: () => setAlert(null)
                    });
                    break;
                default:
                    break;
            }

            setActualizar(!actualizar);
            setseguimientoSelect("");
            setCerrarReporte({})
            setAbrirSeguimiento(false);

        } catch ({ message: descripcion }) {
            setAlert({
                descripcion: descripcion,
                title: "¡Una disculpa!",
                tipo: danger,
                msjConfirmacion: "Aceptar",
                onConfirm: () => setAlert(null)
            });
        }

    }

    const [accionesUsr, setAccionesUsr] = useState();
    if (accionesUsr) {
        acciones = Permisos.ValidarAcciones(acciones, accionesUsr);
        botones = Permisos.ValidarAcciones(botones, accionesUsr);
	    accionesFormulario = Permisos.ValidarAcciones(accionesFormulario, accionesUsr);
    }else{
        Permisos.PermisosAState(setAccionesUsr, token);
    }

    return (<>< Tabla infoTabla={infoTabla}
        asyncData={Consultas.tablaReporteDaniosClientes}
        token={token} />

        <FormularioModal open={open}
            title={titleModal}
            onClose={handleClose}
            notificaciones={notificaciones}
            closeNotification={
                () => setNotificaciones({ ...cleanNotificaciones })
            }
            inputs={inputs}
            acciones={accionesFormulario}
            focus={ArrayRef["UsuarioNombre"]} /> <FormularioModal open={abrirSeguimiento}
                title={"Cerrar reporte de servicio a clientes"}
                onClose={handleCloseSeguimiento}
                notificaciones={notificacionesSeguimiento}
                //closeNotification={() => setNotificacionesSeguimiento({ ...cleanNotificacionesSeguimiento })}
                inputs={inputsSeguimiento}
                acciones={accionesSeguimiento}
                focus={ArrayRef["seguimientoSelect"]} />

            {
             openDocumentacion && <Modal maxWidth={true} onClose={() => {setOpenDocumentacion(false)}}>

                <Documentacion datosDetalleAdjuntos={datosDetalleAdjuntos}   setOpenDocumentacion = { () => setOpenDocumentacion(false)
                } />

            </Modal>
          }
        {
            alert && < SweetAlert title={alert.title}
                descripcion={alert.descripcion}
                tipo={alert.tipo}
                msjConfirmacion={alert.msjConfirmacion}
                msjCancelacion={alert.msjCancelacion}
                onConfirm={alert.onConfirm}
                showConfirm={alert.showConfirm}
                showCancel={alert.showCancel}
                onCancel={
                    () => setAlert(null)
                }
            />} </>
    );
}

export default ReporteDaniosClientes;



